module.exports = __webpack_public_path__ + "img/uniBank.3178d3ae.png";